module.exports = __webpack_public_path__ + "static/img/ptewm.8850659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default1/ptewm.jpg
// module id = Ps2S
// module chunks = 1